
export const setSessionAttribute = (name, data) => {
    console.log(name,JSON.stringify(data))
    sessionStorage.setItem(name, JSON.stringify(data))
}


export const getSessionAttribute = (name) => {
    const value = sessionStorage.getItem(name);
    if (value === null || value === "undefined" || value === "") {
        return null;
    }
    try {
        return JSON.parse(value);
    } catch (error) {
        console.error(`Error parsing session attribute "${name}":`, error);
        return null;
    }
};